import { render, staticRenderFns } from "./V2Spinner.vue?vue&type=template&id=bc50af20&scoped=true&"
import script from "./V2Spinner.vue?vue&type=script&lang=js&"
export * from "./V2Spinner.vue?vue&type=script&lang=js&"
import style0 from "./V2Spinner.vue?vue&type=style&index=0&id=bc50af20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc50af20",
  null
  
)

export default component.exports